import { styled } from '@mui/material/styles'

export const ConfirmModalContentList = styled('ul')({
  maxHeight: '220px',
  paddingLeft: '20px',
  paddingBottom: '30px',
  overflowY: 'scroll',
})
